import { Component, OnInit } from "@angular/core";
import { globalConst } from "src/app/shared/helpers/constants";
import { UmovmeEnvironment } from "../../models/umove-environment.model";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  version = globalConst.version;
  companyName = globalConst.company.name;
  initialYearCopy = globalConst.company.initialYearCopy;
  endYearCopy = globalConst.company.endYearCopy;
  umovmeEnvironment: UmovmeEnvironment = {};

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.umovmeEnvironment = this.authService.getEnvironment();
  }
}
